<div class="youtube-player-container">
  <div id="ytplayer_{{ streamKey }}"></div>
</div>
